class AvisoUsuarioLeitura {
  constructor() {
    
  }
}

export default AvisoUsuarioLeitura
